import React from 'react';
import styles from './index.less';
import footer from '@/assets/image/footer.png';

interface IFooterProps {
}
const Footer: React.FC<IFooterProps> = () => {
  return (
    <div className={styles.footer}>
      <img src={footer} alt="" />
      {/* <div className={styles.text}>
        Copyright © 2022年国家网络安全宣传周组委会版权所有
      </div>
      <div className={styles.text}>
        京ICP备05037055号-55 京公网安备11010702002249号
      </div> */}
    </div>
  );
};

export default Footer;
